import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppMainComponent } from './app.main.component';
import { AppNotfoundComponent } from './pages/notFound/app.notfound.component';
import { ArchiveComponent } from './pages/archive/archive.component';
import { CustomersComponent } from './pages/customers/customers.component';
import { AuthGuard } from './services/auth.guard';
import { PermissionGuard } from './services/permission.guard';
import { OBPermisssionsLocal } from 'src/app/services/auth.service';

import { EdiComponent } from './pages/edi/edi.component';
import { WarehouseComponent } from './pages/warehouse/warehouse.component';
import { SubmittedShipmentsComponent } from './pages/shipment/submitted-shipments/submitted-shipments.component';
import { TrackAndTraceLandingComponent } from './pages/TrackAndTrace/TrackAndTraceLanding/TrackAndTraceLanding.component';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [        
        {
          path: '',
          component: AppMainComponent,
          canActivate: [AuthGuard],
          children: [
            {
              path: '',
              loadChildren: () => import('./pages/frontpage/frontpage.module').then((m) => m.FrontpageModule),
            },
            {
              path: 'booking',
              loadChildren: () => import('./pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
            },
            {
              path: 'shipments',
              loadChildren: () => import('./pages/shipment/shipment.module').then((m) => m.ShipmentsModule),
            },
            { path: 'archive', component: ArchiveComponent },
            { path: 'archive/:id', component: ArchiveComponent }, // TODO: change this into ArchiveComponet afec4203-9f2d-4965-b566-1ac6a0ac52f5
            { path: 'archive/shipment/:id', component: ArchiveComponent },
            
            {
              path: 'customers',
              component: CustomersComponent,
              canActivate: [PermissionGuard],
              data: { permission: OBPermisssionsLocal.ShowCustomers },
            },
            {
              path: 'products',
              loadChildren: () => import('./pages/product-catalog/product-catalog.module').then((m) => m.ProductCatalogModule),
            },
            {
              path: 'warehouse',
              component: WarehouseComponent,
              // canActivate: [PermissionGuard],
              // data: { permission: OBPermisssionsLocal.Warehouse },
            },
            {
              path: 'edi',
              component: EdiComponent,
              canActivate: [PermissionGuard],
              data: { permission: OBPermisssionsLocal.UploadEDIFiles },
            },
            {
              path: 'my',
              loadChildren: () => import('./pages/my-page/my-page.module').then((m) => m.MyPageModule),
            },
          ],
        },        
        {path:'trackandtrace/:id',component:TrackAndTraceLandingComponent},        
        { path: 'notfound', component: AppNotfoundComponent },
        { path: 'forbidden', loadChildren: () => import('./pages/accessdenied/accessdenied.module').then((m) => m.AccessdeniedModule) },
        { path: '**', redirectTo: '/notfound' },
      ],
      {
        scrollPositionRestoration: 'enabled',
        useHash: false,
      }
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
